import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
    name: 'locale',
    props: {
        onlyselect : Boolean,
        available : Array,
        editing : Boolean,
        initial : String
    },

    data : function(){

        return {
            loading : false,
            wasvalue : null,
            value : null
        }

    },

    components : {
    },

    beforeDestroy (){


    },

    created(){

        if (this.initial){
            this.value = this.initial
        }

        if (!this.value && this.userinfo?.locale){
            this.value = this.userinfo?.locale
        }

        if(!this.value){

        }
        else{
            this.wasvalue = this.value
        }

        if (this.locales.indexOf(this.value) == -1) this.value = this.locales[0]

        setTimeout(() => {
            this.ready = true
        }, 30)

    },

    watch: {
        value : function(){

            
        }
    },
    computed: mapState({
        auth : state => state.auth,
        userinfo : state => state.userinfo?.userinfo,
        nothingChanges : function(){

            if(!this.wasvalue || !this.editing) return false

            return this.wasvalue == this.value
            
        },
        locales : function(){
            return this.available || f.deep(this.core, 'appInfo.snippity.settings.locales') || []
        },

        fields : function(){
            return [
                {
                    id: 'locale',
                    input: 'select',
                    text: 'snippity.selectlocaleLabel',
                    values : _.map(this.locales, (locale) => {
                        return {
                            value : locale,
                            text : "locales." + locale
                        }
                    })
                },
            ]
        }


    }),

    methods : {
       
        setlocale : function(){

            //TODO TEST

            if(this.onlyselect){

                this.$emit('select', this.value)
                this.$emit('close')
                
                return
            }

            this.$store.commit('globalpreloader', true)
            

            this.core.user.infoEdit({
                info : {
                    locale : this.value
                }
            }).then(() => {

                this.$emit('change', this.value)
                this.$emit('close')

            }).catch(e => {

                console.error(e)

                this.$store.commit('icon', {
					icon: 'error',
					message: this.$t(e.error || "errors.general")
				})

            }).finally(() => {
				this.$store.commit('globalpreloader', false)
			})
            
        },

        cancel : function(){
            this.$emit('close')
        },

        input : function(v){
            this.value = v.locale
        }
    },
}